import { useEffect, ForwardedRef, useState, useImperativeHandle, forwardRef } from 'react';
import { Tabs, Spin } from 'antd';
import css from '../index.module.scss';
import styled from './index.module.scss';
import { ICouponDetail, ShareType } from '@/components/Referral/index.d';
import EfModal from '@/components/UI/Modal';
import { NoDataIcon } from '@/components/UI/svg/Ecocredits';
import { getPoints, getDiscount, getGiftCard, getPageCash } from '@/service/referral';
import { useGlobal } from '@/utils/useGlobal';
import { message } from '@/components/UI';
import Coupon from '@/components/Referral/Receive/Rewards/Coupon';
import { withdrawalWhiteLocale } from '@/constants/my';

const { TabPane } = Tabs;

interface RewardsModalProps {
    isActivity?: boolean; // 是否只显示本次活动的
    planId?: string;
}

export type RewardsModalHandle = {
    show: () => void;
};

const RewardsModal = ({ isActivity = true, planId }: RewardsModalProps, ref: ForwardedRef<RewardsModalHandle>) => {
    const { useLang, useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const [active, setActive] = useState('points');
    const [data, setData] = useState<Record<string, ICouponDetail[] | null>>({
        discount: null,
        gift: null,
        points: null,
    });
    const [show, setShow] = useState(false);

    useImperativeHandle(ref, () => ({
        show: () => setShow(true),
    }));

    useEffect(() => {
        let getData = null;
        if (active === 'discount') {
            getData = getDiscount;
        } else if (active === 'gift') {
            getData = getGiftCard;
        } else if (active === 'cash') {
            getData = getPageCash;
        } else {
            getData = getPoints;
        }
        const params = { size: -1, shareType: ShareType.SHARER };
        if (isActivity) {
            if (!planId) return;
            Object.assign(params, {
                planId,
            });
        }
        getData(params, locale).then((res) => {
            if (res.code !== '0') return message.error(res.message);
            const obj = { ...data };
            obj[active] = res.data.content || [];
            setData(obj);
        });
    }, [active, planId]);

    const NoData = () => (
        <div className="no-content">
            <div className="no-content-icon">
                <NoDataIcon />
            </div>
            <p className="no-content-note">{t('no_data')}</p>
        </div>
    );

    return (
        <EfModal
            width={800}
            visible={show}
            className={`${css.refer_modal} ${styled.rewards_modal}`}
            onCancel={() => setShow(false)}
            maskClosable={isMobile}
            centered={!isMobile}
        >
            <h5 className="title">{t('rewards_redeemed')}</h5>
            <Tabs className="bonus_tabs" activeKey={active} onChange={(val) => setActive(val)} centered>
                <TabPane tab={t('ecocredits')} key="points" />
                <TabPane tab={t('discount')} key="discount" />
                <TabPane tab={t('gift_card')} key="gift" />
                {withdrawalWhiteLocale.includes(locale) && <TabPane tab={t('cash')} key="cash" />}
            </Tabs>
            <div className="modal_body">
                {!data[active] ? (
                    <Spin />
                ) : data[active]?.length === 0 ? (
                    <NoData />
                ) : (
                    <div className="coup_box">
                        {data[active]?.map((item, index) => (
                            <div key={index}>
                                <Coupon coupon={item} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </EfModal>
    );
};

export default forwardRef<RewardsModalHandle, RewardsModalProps>(RewardsModal);
